<template>
  <div class="ticket_info_way">
    <div class="ticket_info_way_title ticket_icon">
      <img :src="staticAssets.ImgObj.ticket_icon" alt />
      <span>{{TLang('取票方式','my')}}</span>
    </div>

    <div
      class="ticket_info_way_img card_img"
      v-if="
        detailSourceData.issueTickType == 4 &&
          detailSourceData.deliveryType == 1
      "
    >
      <div class="ticket_img_show" :style="card_style">
        <img
          :src="staticAssets.ImgObj.card_icon2"
          alt
          style="width: 26px;margin: 0px 5px 0 16px;"
        />
        <span style="font-size:14px;font-weight:600;color:rgba(61,150,226,1);"
          >{{TLang('身份证电子票','my')}}</span
        >
      </div>
    </div>
    <!-- 快递配送展示 -->
    <div
      class="ticket_info_way_img ticket_img"
      v-if="
        detailSourceData.issueTickType == 1 &&
          detailSourceData.deliveryType == 2
      "
      style="width:123px;"
    >
      <div class="ticket_img_show kuaidi_Warp" :style="ticket_style">
        <img
          :src="staticAssets.ImgObj.ticket_kuaidi_icon"
          alt
          style="width: 25px;margin: 0px 6px 0 18px;"
        />
        <span style="font-size:14px;font-weight:600;color:rgba(61,150,226,1);"
          >{{TLang('快递配送','my')}}</span
        >
      </div>
    </div>

    <!-- 上门自取 -->
    <div
      class="ticket_info_way_img ticket_img"
      v-if="
        detailSourceData.issueTickType == 1 &&
          detailSourceData.deliveryType == 4
      "
      style="width:123px;"
    >
      <div class="ticket_img_show kuaidi_Warp" :style="ticket_style">
        <img
          :src="staticAssets.ImgObj.ziqu_icon"
          alt
          style="width: 25px;margin: 0px 6px 0 18px;"
        />
        <span style="font-size:14px;font-weight:600;color:rgba(61,150,226,1);"
          >{{TLang('上门自取','my')}}</span
        >
      </div>
    </div>
    <!-- 自助机取票 -->
    <div
      class="ticket_info_way_img ticket_img"
      v-if="detailSourceData.deliveryType == 3"
      style="width:138px;"
    >
      <div class="ticket_img_show kuaidi_Warp" :style="ticket_style">
        <img
          :src="staticAssets.ImgObj.machine_icon"
          alt
          style="width: 22px;margin: 0px 6px 0 17px;"
        />
        <span style="font-size:14px;font-weight:600;color:rgba(61,150,226,1);"
          >{{TLang('自助机取票','my')}}</span
        >
      </div>
    </div>
    <!-- 电子票样式 -->
    <div
      class="ticket_info_way_img ticket_img"
      v-if="
        detailSourceData.issueTickType != 1 &&
          detailSourceData.issueTickType != 4 &&
          detailSourceData.deliveryType != 3
      "
    >
      <div class="ticket_img_show" :style="ticket_style" style="width:114px">
        <img
          :src="staticAssets.ImgObj.ticket_icon2"
          alt
          style="width: 25px;margin: 0px 6px 0 18px;"
        />
        <span style="font-size:14px;font-weight:600;color:rgba(61,150,226,1);"
          >{{TLang('电子票','my')}}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "drama_watcher",
  data() {
    return {
      detailSourceData: this.sourceData,
      machine_style:
        "width:138px;height:100%;background:url(" +
        require("../../assets/imgs/machine_icon_back.png") +
        ") no-repeat;align-items: center;background-size:100% 100%;display: flex;",
      ticket_style:
        "width:138px;height:100%;background:url(" +
        require("../../assets/imgs/ticket_icon_back.png") +
        ") no-repeat;align-items: center;background-size:100% 100%;display: flex;",
      card_style:
        "width:146px;height:100%;background:url(" +
        require("../../assets/imgs/card_icon_back.png") +
        ") no-repeat;align-items: center;background-size:100% 100%;display: flex;background-size:100% 100%"
    };
  },
  props: ["sourceData"],
  watch: {
    sourceData: {
      handler: function(newVal) {
        this.detailSourceData = newVal;
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style lang="less" scoped>
.ticket_icon {
  line-height: 21px;
}
.ticket_icon img {
  width: 20px;
  height: 20px;
  display: inline-block;
  // vertical-align: middle;
}
.ticket_icon span {
  display: inline-block;
  margin-left: 15px;
  font-size: 16px;
  color: #111111;
  line-height: 21px;
  height: 21px;
}
.ticket_info_way {
  .ticket_info_way_title {
    display: flex;
    align-items: center;
  }
}
.ticket_info_way_img {
  height: 40px;
  margin-top: 16px;
  margin-left: 32px;
  margin-bottom: 24px;
}
.card_img {
  width: 146px;
}
.ticket_img {
  width: 114px;
}
.kuaidi_Warp {
  width: 138px !important;
}
</style>
<style lang="less">
.qr_code_card {
  height: 32px;
  font-size: 12px;
  padding: 8px 12px;
  padding-top: 7px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 2px 0px #ececec;
  span {
    display: inline-block;
    color: rgba(51, 51, 51, 1);
    line-height: 16px;
  }
}
</style>
